var resources = require('items-view-strings');
    var strings = resources['_jAjwK5kNfDUjJ/VI8nbGZQ'];
export { strings };
export default strings;
